import {useCallback, useEffect} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getSearchesEntityIdsCounts} from 'src/openapi/admin/apis/UserContentIdCountApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
    ids: (string | number)[],
};

export const useGetSearchesEntityIdsCounts = ({userId, ids}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => {
        return apiDispatch(
            getSearchesEntityIdsCounts({userId, requestBody: ids.map(id => String(id))}),
        );
    }, [userId, ids, apiDispatch]);

    const {data, isLoading, loadData, loadingError} = useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
        shouldLoadData: false,
    });

    useEffect(() => {
        if (ids.length) {
            loadData();
        }
    }, [ids, loadData]);

    return {data, isLoading, load: loadData, loadingError};
};
